import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { faWrench, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { DayBookService } from 'src/app/share/services/day-book/day-book.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonServiceService } from 'src/app/share/services/common-service/common-service.service';

@Component({
  selector: 'app-day-book-services',
  templateUrl: './day-book-services.component.html',
  styleUrls: ['./day-book-services.component.scss'],
  standalone: false
})
export class DayBookServicesComponent implements OnChanges {
  readonly faWrench = faWrench;
  readonly faChevronRight = faChevronRight;
  @Input() selectedDate: any;
  @Input() selectedBranch: any;


  totalJobs: number = 0;
  serviceValue: number = 0;

  servicesList: any[] = [];
  loader: boolean = false;
  errMsg: string = '';

  constructor(
    private readonly dayBookService: DayBookService,
    private readonly modalService: NgbModal,
    private readonly cmnService: CommonServiceService,
  ) { }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedDate'] || changes['selectedBranch']) {
      this.totalJobs = 0;
      this.serviceValue = 0;
      this.servicesList = [];
      this.getData();
    }
  }

  getData() {
    this.loader = true;
    this.errMsg = '';
    let params: any = {
      created_date: this.selectedDate
    }
    if (this.selectedBranch) {
      params.company = this.selectedBranch
    }
    this.dayBookService.getServices(params).subscribe({
      next: (res: any) => {
        this.loader = false
        this.mapResponse(res.data || {})
      },
      error: (err: any) => {
        this.loader = false;
        this.errMsg = err?.error?.error?.message || "Failed to fetch response"
      }
    })
  }

  mapResponse(data: any) {
    this.totalJobs = this.cmnService.parseNumberOrZero(data?.totalJobs);
    this.serviceValue = this.cmnService.parseNumberOrZero(data?.serviceValue);
    if (data.breakdown?.length) {
      let tabledata: any[] = (data.breakdown || []).map((item: any) => {
        return { ...item, jobs: this.cmnService.parseNumberOrNull(item?.jobs), sales: this.cmnService.parseNumberOrNull(item?.sales) };
      });
      this.servicesList = tabledata
    } else {
      this.errMsg = "No data found"
    }
  }

  viewAllServices(modalContent: any) {
    this.modalService.open(modalContent, { size: 'lg', centered: true, scrollable: true });
  }

}
